import React from 'react'
import * as S from './styles'
import { ReactComponent as SpinnerSvg } from 'static/svg/spinner.svg'
import { ReactComponent as DangerSvg } from 'static/svg/exclamation-icon-variant.svg'
import { Typography } from '@telavita-core/react-design-kit'

interface AutoSavingProps {
  text: string;
  hasError?: boolean;
}

export function AutoSavingFeedback({ text, hasError }: AutoSavingProps): JSX.Element {
  return (
    <S.AutoSavingContainer hasError={hasError}>
      {hasError ?
        <DangerSvg width={19} height={19} /> : (
          <S.SpinnerContainer>
            <SpinnerSvg width={32} height={32} />
          </S.SpinnerContainer>
        )}
      <S.AutoSavingText hasError={hasError}>
        <Typography variant="content3">{text}</Typography>
      </S.AutoSavingText>
    </S.AutoSavingContainer >
  )
}
